/**
 * ICP Network Configuration
 * Auto-detects environment and provides correct network settings
 */

import canisterIds from './canister_ids.json';

// Detect if running in local development
const isLocalDevelopment = () => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || 
         hostname === '127.0.0.1' || 
         hostname.includes('localhost');
};

// Get the correct network
export const getNetwork = () => {
  return isLocalDevelopment() ? 'local' : 'ic';
};

// Get the correct IC host
export const getICHost = () => {
  return isLocalDevelopment() ? 'http://127.0.0.1:4943' : 'https://ic0.app';
};

// Get canister ID for a specific canister
export const getCanisterId = (canisterName) => {
  const network = getNetwork();
  const ids = canisterIds[canisterName];
  
  if (!ids) {
    console.warn(`⚠️ Canister ID not found for: ${canisterName}`);
    return null;
  }
  
  // Use 'ic' for mainnet, 'local' for development
  const canisterId = ids[network] || ids.ic;
  
  if (!canisterId) {
    console.warn(`⚠️ No canister ID for ${canisterName} on network ${network}`);
    return null;
  }
  
  return canisterId;
};

// Create properly configured HttpAgent
export const createAgent = async (HttpAgent) => {
  const host = getICHost();
  const isLocal = isLocalDevelopment();
  
  console.log(`🌐 Creating IC agent for ${isLocal ? 'LOCAL' : 'MAINNET'} network`);
  console.log(`📡 Host: ${host}`);
  
  const agent = new HttpAgent({ host });
  
  // SECURITY: Only fetch root key in local development
  // Never call this on mainnet as it disables certificate validation
  if (isLocal) {
    console.log('🔓 Fetching root key (local development only)');
    await agent.fetchRootKey();
  } else {
    console.log('🔒 Using mainnet certificates (secure)');
  }
  
  return agent;
};

// Get all canister IDs for the current network
export const getAllCanisterIds = () => {
  const network = getNetwork();
  const ids = {};
  
  Object.keys(canisterIds).forEach(canisterName => {
    ids[canisterName] = getCanisterId(canisterName);
  });
  
  return ids;
};

// Log current configuration
export const logNetworkConfig = () => {
  const network = getNetwork();
  const host = getICHost();
  const isLocal = isLocalDevelopment();
  
  console.log('═══════════════════════════════════════════');
  console.log('🌐 ICP NETWORK CONFIGURATION');
  console.log('═══════════════════════════════════════════');
  console.log(`Environment: ${isLocal ? 'LOCAL DEVELOPMENT' : 'PRODUCTION'}`);
  console.log(`Network: ${network}`);
  console.log(`IC Host: ${host}`);
  console.log(`Location: ${window.location.href}`);
  console.log('───────────────────────────────────────────');
  console.log('Available Canisters:');
  
  const ids = getAllCanisterIds();
  Object.entries(ids).forEach(([name, id]) => {
    if (id) {
      console.log(`  ${name}: ${id}`);
    }
  });
  
  console.log('═══════════════════════════════════════════');
};

export default {
  isLocalDevelopment,
  getNetwork,
  getICHost,
  getCanisterId,
  createAgent,
  getAllCanisterIds,
  logNetworkConfig
};

